export enum WidgetFormat {
  Center = 'center',
  Fit = 'fit',
  Fullscreen = 'fullscreen',
  Wide = 'wide',
}
